(() => {
  if (window.tengliWatchModalReady) return;
  window.tengliWatchModalReady = true;

  let activeModal;
  let activeTrigger;

  const closeModal = (restoreFocus = true) => {
    if (!activeModal) return;

    const video = activeModal.querySelector('.tengli-watch-modal__video');
    video.pause();
    video.removeAttribute('src');
    video.load();
    activeModal.hidden = true;
    document.body.classList.remove('tengli-watch-modal-open');

    if (restoreFocus && activeTrigger?.isConnected) activeTrigger.focus();
    activeModal = undefined;
    activeTrigger = undefined;
  };

  const openModal = (trigger) => {
    closeModal(false);

    const watchSection = trigger.closest('.tengli-watch');
    const modal = watchSection?.querySelector('[data-tengli-watch-modal]');
    const video = modal?.querySelector('.tengli-watch-modal__video');
    if (!modal || !video || !trigger.dataset.videoSrc) return;

    document.querySelectorAll('.tengli-watch-modal__video').forEach((otherVideo) => {
      if (otherVideo !== video) otherVideo.pause();
    });

    activeModal = modal;
    activeTrigger = trigger;
    video.src = trigger.dataset.videoSrc;
    modal.hidden = false;
    document.body.classList.add('tengli-watch-modal-open');
    modal.querySelector('.tengli-watch-modal__close').focus();
    video.play().catch(() => {});
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tengli-watch-trigger]');
    if (trigger) {
      openModal(trigger);
      return;
    }

    if (activeModal && event.target.closest('[data-tengli-watch-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeModal) closeModal();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (activeModal && event.target.contains(activeModal)) closeModal(false);
  });
})();
